import request from '@/router/axios';
 
// 汇总统计
export const selectCustTransBehavior = (data) => {
    return request({
        url: '/api/produce/data-statistics/selectCustTransBehavior',
        method: 'post',
        data
    })
}
//客户发运频次统计 
export const custShipFrequency = (data) => {
    return request({
        url: '/api/produce/data-statistics/custShipFrequency',
        method: 'post',
        data
    })
}
//年度运输趋势统计： 
export const yearlyShipmentTrend = (data) => {
    return request({
        url: '/api/produce/data-statistics/yearlyShipmentTrend',
        method: 'post',
        data
    })
}
//煤种偏好分析： 
export const cargoPreferenceAnalysis = (data) => {
    return request({
        url: '/api/produce/data-statistics/cargoPreferenceAnalysis',
        method: 'post',
        data
    })
}
//季度运输分析： 
export const quarterlyShipmentAnalysis = (data) => {
    return request({
        url: '/api/produce/data-statistics/quarterlyShipmentAnalysis',
        method: 'post',
        data
    })
}

// 获取单位
export const getDeptSelect = () => {
    return request({
        url: '/api/produce/cust-info/select/distinct/pycode',
        method: 'get',
    })
}